import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'

import { getFormLink } from '../../helpers/getFormLink'
import { isUserHasAccess } from '../../helpers/isUserHasAccess'

import { translationKey } from './configs'
import { IELTFormProps } from './models'

import styles from './EltFormOpener.module.scss'

export const EltFormOpener = ({
  partnerId,
  fYear,
  withoutPadding,
  show = true,
  groupUID,
  variant,
}: IELTFormProps) => {
  const user = useSelector(selectUser)
  const border = withoutPadding ? styles.withoutPadding : styles.eltBtn
  const link = getFormLink(partnerId, fYear, groupUID)
  const isRenderButton = isUserHasAccess(user.roleIds) && show

  return (
    <RenderWhen condition={isRenderButton}>
      <div className={border}>
        <Button to={link} target={'_blank'} rel={'noreferrer'} variant={variant}>
          <Translation text={translationKey} />
        </Button>
      </div>
    </RenderWhen>
  )
}
